import React from 'react';
import PartnerSection from '../PartnerSection';
import CountUp from 'react-countup';
import sIcon1 from '../../images/icons/icon_head.svg'
import sIcon2 from '../../images/icons/icon_check.svg'
import sIcon3 from '../../images/icons/icon_like.svg'
import sIcon4 from '../../images/icons/icon_dart_board.svg'
import Bg from '../../images/shapes/bg_pattern_1.svg'
import pp1 from '../../images/pp1.png'
import pp2 from '../../images/pp2.png'
import pp3 from '../../images/pp3.png'
import pp4 from '../../images/pp4.png'
import pp5 from '../../images/pp5.png'


const FeaturesSection = (props) => {

    return (
        <section className="client_logo_section section_space">
            <div className="container">
                <div className="section_space pt-0 pb-0">
                    <div className="heading_block text-center">
                        <div className="heading_focus_text mb-0">
                            <h4 className='client_head'>Connect to any of our 100+ booking channels to drive your business growth</h4>
                        </div>
                    </div>
                    <ul className='partner_list unordered_list justify-content-center'>
                        <li>
                            <img src={pp1} alt="Techco - SVG Icon Head" />
                        </li>
                        <li>
                            <img src={pp2} alt="Techco - SVG Icon Head" />
                        </li>
                        <li>
                            <img src={pp3} alt="Techco - SVG Icon Head" />
                        </li>
                        <li>
                            <img src={pp4} alt="Techco - SVG Icon Head" />
                        </li>
                        <li>
                            <img src={pp5} alt="Techco - SVG Icon Head" />
                        </li>
                    </ul>
                    {/* <PartnerSection /> */}
                </div>

                {/* <div className="row funfact_wrapper">
                    <div className="col-lg-8">
                        <div className="row">
                            {FunFact.map((funfact, fitem) => (
                                <div className="col-md-6" key={fitem}>
                                    <div className="funfact_block">
                                        <div className="funfact_icon">
                                            <img src={funfact.icon} alt="Techco - SVG Icon Head" />
                                        </div>
                                        <div className="funfact_content">
                                            <div className="counter_value">
                                                <span className="odometer" data-count="25"><CountUp end={funfact.title} enableScrollSpy /></span>
                                                <span>{funfact.symbol}</span>
                                            </div>
                                            <h3 className="funfact_title mb-0">{funfact.subTitle}</h3>
                                        </div>
                                    </div>
                                </div>
                            ))}

                        </div>
                    </div>
                    <div className="col-lg-4">
                        <div className="our_world_employees">
                            <div className="image_wrap">
                                <img src={fimg} alt="Techco - Employees Guoup" />
                            </div>
                            <div className="content_wrap">
                                <h3 className="title_text mb-0">
                                    <b className="d-block">12000+</b> employees in 30 countries in Europe
                                </h3>
                            </div>
                        </div>
                    </div>
                </div> */}

            </div>
        </section>
    );
}

export default FeaturesSection;